const EMAIL = "info@carthyai.com";

function findExchangeSection() {
  return Array.from(document.querySelectorAll("section#contact")).find((section) => {
    const text = (section.textContent || "").replace(/\s+/g, " ").trim();
    return text.includes("Échangeons") || text.includes("Let's talk about your infrastructure");
  });
}

function applyContactActions() {
  const section = findExchangeSection();
  if (!section) return false;

  section.dataset.carthyContactActions = "single-email";

  const mailLink = section.querySelector('a[href^="mailto:"]');
  if (mailLink) {
    const english = document.documentElement.lang === "en";
    const subject = english ? "CARTHY consultation request" : "Demande de consultation CARTHY";
    mailLink.href = `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}`;
    mailLink.dataset.carthyContactEmail = EMAIL;
  }

  section.querySelectorAll('a[href="#services"]').forEach((link) => link.remove());
  return true;
}

function boot() {
  applyContactActions();

  const observer = new MutationObserver(() => applyContactActions());
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  window.addEventListener("carthy-language-change", applyContactActions);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
